import React from 'react';

import classes from './Toolbar.css';
import Logo from '../../Logo/Logo';
import NavigationItems from '../NavigationItems/NavigationItems';
import DrawerToggle from '../SideDrawer/DrawerToggle/DrawerToggle';

const toolbar = (props) => ( //обвертка панели инструментов (базовая рабочяя панель инструментов)
    <header className={classes.Toolbar}>  
        < DrawerToggle clicked={props.drawerToggleClicked}/>
        <div className={classes.Logo}>
            <Logo />
        </div>       
        <nav className={classes.DesktopOnly}>
            <NavigationItems isAuthenticated={props.isAuth}/>
        </nav>
    </header>   
);

export default toolbar;


// WEBPACK FOOTER //
// ./src/components/Navigation/Toolbar/Toolbar.js